"use strict";var $export=require("./_export");$export($export.S+$export.F*!require("./_descriptors"),"Object",{defineProperties:require("./_object-dps")});